import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BuildingAddressDirective } from '@cfp/shared/building/address-module';
import { StreetViewImageComponent } from '@cfp/shared/ui/street-view-image';
import { CurrencyModule, Icon } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';
import {
  CurrencyCodeDTO,
  LloydsPortfolioEnergyConsumptionTotalsDTO,
  LloydsRoadmapPortfolioBuildingDTO
} from 'csr-asset-app';

@Component({
  selector: 'cfp-lbg-report-energy-consumption-table',
  templateUrl: 'lbg-report-energy-consumption-table.html',
  styleUrls: ['lbg-report-energy-consumption-table.scss'],
  imports: [StreetViewImageComponent, BuildingAddressDirective, TranslateModule, DecimalPipe, CurrencyModule, Icon],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LbgReportEnergyConsumptionTable {
  public readonly buildings = input.required<LloydsRoadmapPortfolioBuildingDTO[]>();
  public readonly currencyCode = input.required<CurrencyCodeDTO>();
  public readonly totals = input<LloydsPortfolioEnergyConsumptionTotalsDTO | undefined>(undefined);
  public readonly showTotals = input(false);
}
